export default "__VITE_ASSET__DrDUzOma__"